import { useState, useEffect } from "react";
import { useSaveFooterContentMutation, useGetFooterContentQuery, useUpdateFooterContentMutation, useGetPaymentIconsQuery } from "../../Services/SettingsAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faCircleInfo } from "@fortawesome/free-solid-svg-icons";


function AddCategory() {
    const { data, refetch } = useGetFooterContentQuery();
    const [favIcon, setFavIcon] = useState(null);
    const [selectedFavIcon, setSelectedFavIcon] = useState("");
    const [showPaymentPopup, setShowPaymentPopup] = useState(false);
    // const [selectedFooterImages, setSelectedFooterImages] = useState("");
    const [extraFields, setExtraFields] = useState({
        login_active: false,
        register_active: false,
        wishlist_active: false,
        track_order_active: false,
        about_us_active: false,
        how_to_order_active: false,
        how_to_track_active: false,
        // size_track_active: false,
    });

    // const [selectedImages, setSelectedImages] = useState([]);
    const [headerText, setHeaderText] = useState({
        copyright_app_name: "",
        header_text_one: "",
        header_text_two: "",
        header_text_three: "",
        header_text_four: "",
    });

    useEffect(() => {
        if (data?.data?.length > 0) {
            setExtraFields({
                login_active: data.data[0].login_active === 1,
                register_active: data.data[0].register_active === 1,
                wishlist_active: data.data[0].wishlist_active === 1,
                track_order_active: data.data[0].track_order_active === 1,
                about_us_active: data.data[0].about_us_active === 1,
                how_to_order_active: data.data[0].how_to_order_active === 1,
                how_to_track_active: data.data[0].how_to_track_active === 1,
                // size_track_active: data.data[0].size_track_active === 1,
            });
            localStorage.setItem("Appname", data?.data[0]?.copyright_app_name);
            localStorage.setItem("favIcon", data?.data[0]?.fav_icon_path);

            setSelectedFavIcon(data.data[0].fav_icon_path);
            // setSelectedFooterImages(data?.data[0]?.footer_images)
            setHeaderText({
                copyright_app_name: data.data[0].copyright_app_name || "",
                header_text_one: data.data[0].header_text_one || "",
                header_text_two: data.data[0].header_text_two || "",
                header_text_three: data.data[0].header_text_three || "",
                header_text_four: data.data[0].header_text_four || "",
            });
        }
    }, [data]);

    const [apiError, setApiError] = useState(null);
    const [addPaymentMethods, { isLoading }] = useSaveFooterContentMutation();
    const [UpdateFooterContent, { isLoading: updating }] = useUpdateFooterContentMutation();
    const { data: paymentIcons, refetch: refetchPaymentIcons } = useGetPaymentIconsQuery();
    const [selectedPayments, setSelectedPayments] = useState({});


    const handlePaymentCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setSelectedPayments((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };


    useEffect(() => {
        if (paymentIcons?.length > 0) {
            const initialPayments = {};
            paymentIcons.forEach((icon) => {
                initialPayments[icon.name] = icon.status === 1;
            });
            setSelectedPayments(initialPayments);
        }
    }, [paymentIcons]);


    const handleExtraFieldChange = (e) => {
        const { name, checked } = e.target;
        setExtraFields((prevState) => ({
            ...prevState,
            [name]: checked,
        }));
    };

    // const handleFileChange = (e) => {
    //     const files = Array.from(e.target.files);
    //     setSelectedImages(files);
    // };

    const handleTextChange = (e) => {
        const { name, value } = e.target;
        setHeaderText((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleFavIconChange = (e) => {
        const fileInput = e.target;
        const file = fileInput.files[0];

        if (file) {
            const allowedTypes = ["image/x-icon", "image/png", "image/vnd.microsoft.icon"];
            if (!allowedTypes.includes(file.type)) {
                alert("Only .ico and .png files are allowed for the favicon.");
                fileInput.value = "";
                setFavIcon(null);
                return;
            }
            setFavIcon(file);
        } else {
            setFavIcon(null);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        Object.keys(extraFields).forEach((key) => {
            formData.append(key, extraFields[key] ? 1 : 0);
        });

        // selectedImages.forEach((image) => {
        //     formData.append("footer_images[]", image);
        // });

        const gateways = paymentIcons.map((icon) => ({
            id: icon.id,
            status: selectedPayments[icon.name] ? 1 : 0, // If checked, status is 1, else 0
        }));

        // Append the 'gateways' data to formData as an array
        formData.append("gateways", JSON.stringify(gateways));

        if (favIcon) {
            formData.append("fav_icon", favIcon);
        }

        Object.keys(headerText).forEach((key) => {
            formData.append(key, headerText[key]);
        });

        try {
            if (data?.data?.length > 0) {
                const id = data?.data?.[0]?.id;
                await UpdateFooterContent({ formData, id }).unwrap();
                alert("Settings updated successfully!");
                refetch();
                refetchPaymentIcons();
                window.location.reload();
            } else {
                await addPaymentMethods(formData).unwrap();
                alert("Settings updated successfully!");
                refetch();
                refetchPaymentIcons();
                window.location.reload();
            }

            setExtraFields({
                login_active: false,
                register_active: false,
                wishlist_active: false,
                track_order_active: false,
                about_us_active: false,
                how_to_order_active: false,
                how_to_track_active: false,
                size_track_active: false,
            });

            setHeaderText({
                copyright_app_name: "",
                header_text_one: "",
                header_text_two: "",
                header_text_three: "",
                header_text_four: "",
            });

            // setSelectedImages([]);
            setApiError(null);
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };
    const customLabels = {
        how_to_order_active: "Privacy Policy",
        how_to_track_active: "Terms and Conditions",
    };

    const handleAddPaymentIcons = () => {
        setShowPaymentPopup(false);
    };


    return (
        <div>
            <h3>Website Settings</h3>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit} encType="multipart/form-data">

                    {/* Copyright Section */}
                    {/* <h5 className="mt-3 mb-4">Copyright Settings</h5> */}
                    <div className="mb-3">
                        <label htmlFor="copyright_app_name" className="form-label">
                            App Name
                        </label>
                        <input
                            type="text"
                            id="copyright_app_name"
                            name="copyright_app_name"
                            className="form-control"
                            value={headerText.copyright_app_name}
                            onChange={handleTextChange}
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="fav_icon" className="form-label">
                            Upload Favicon
                        </label>
                        <input
                            type="file"
                            id="fav_icon"
                            className="form-control"
                            onChange={handleFavIconChange}

                        />
                    </div>
                    {selectedFavIcon && <img src={selectedFavIcon} alt="fav-icon" width={50} height={50} />}


                    {/* Header Settings */}
                    <h5 className="mt-4 mb-4"><b>Top Header</b></h5>
                    <div className="row">
                        {["header_text_one", "header_text_two", "header_text_three", "header_text_four"].map((field) => (
                            <div className="col-md-6" key={field}>
                                <div className="mb-3">
                                    <label htmlFor={field} className="form-label">
                                        {field.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())}
                                    </label>
                                    <input
                                        type="text"
                                        id={field}
                                        name={field}
                                        className="form-control"
                                        value={headerText[field]}
                                        onChange={handleTextChange}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Footer Settings */}
                    <h5 className="mt-4 mb-4"><b>Footer<div className="tooltip-container">
                        <FontAwesomeIcon
                            icon={faCircleInfo}
                            className="text-warning mx-2"
                            style={{ cursor: "pointer" }}
                        />
                        <div className="tooltip">The selected option will be displayed in the  Footer section.</div>
                    </div></b></h5>
                    <div className="row">
                        {Object.keys(extraFields).map((field) => (
                            <div className="col-md-3 col-sm-6" key={field}>
                                <div className="mb-3">
                                    <input
                                        type="checkbox"
                                        id={field}
                                        name={field}
                                        className="form-check-input"
                                        checked={extraFields[field]}
                                        onChange={handleExtraFieldChange}
                                    />
                                    <label htmlFor={field} className="form-label">
                                        {customLabels[field] || field
                                            .replace(/_active$/, "")
                                            .replace(/_/g, " ")
                                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                                    </label>


                                </div>
                            </div>
                        ))}
                    </div>

                    {/* File Upload Field for Images */}
                    {/* <div className="mb-3 mt-4">
                        <label className="form-label">Upload Footer Images:</label>
                        <input
                            type="file"
                            name="footer_images"
                            className="form-control"
                            multiple
                            onChange={handleFileChange}
                            accept="image/*"
                        />
                    </div>
                    {selectedImages.length > 0 ? (
                        <div className="mb-3">
                            <h5>Selected Images:</h5>
                            <div className="d-flex flex-wrap">
                                {selectedImages.map((image, index) => (
                                    <div key={index} className="me-2">
                                        <img
                                            src={image instanceof File ? URL.createObjectURL(image) : image}
                                            alt={`Preview ${index + 1}`}
                                            width={80}
                                            height={80}
                                            className="rounded border"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : selectedFooterImages.length > 0 ? (
                        <div className="mb-3">
                            <h5>Selected Images:</h5>
                            <div className="d-flex flex-wrap">
                                {selectedFooterImages.map((image, index) => (
                                    <div key={index} className="me-2">
                                        <img
                                            src={image instanceof File ? URL.createObjectURL(image) : image}
                                            alt={`Preview ${index + 1}`}
                                            width={80}
                                            height={80}
                                            className="rounded border"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        ""
                    )} */}

                    {/* <div className="row">
                        <h6 className="mb-4"><b>Payment gateway Icons <div className="tooltip-container">
                            <FontAwesomeIcon
                                icon={faCircleInfo}
                                className="text-warning mx-2"
                                style={{ cursor: "pointer" }}
                            />
                            <div className="tooltip">The selected payment option will be displayed in the  Footer section.</div>
                        </div></b></h6>
                        {paymentIcons?.map((icon) => (
                            <div className="col-md-3 col-sm-6" key={icon.id}>
                                <div className="mb-3 form-check">
                                    <input
                                        type="checkbox"
                                        id={`payment-${icon.id}`}
                                        name={icon.name}
                                        className="form-check-input"
                                        checked={selectedPayments[icon.name] || false}
                                        onChange={handlePaymentCheckboxChange}
                                    />
                                    <label htmlFor={`payment-${icon.id}`} className="form-check-label">
                                        {icon.name}
                                    </label>
                                </div>
                            </div>
                        ))}

                    </div> */}

                    <div className="row mb-4 mt-4">
                        <div>
                            <button type="button" className="add-paymet-icons" onClick={() => setShowPaymentPopup(true)}>
                            <FontAwesomeIcon
                                icon={faAdd}
                                className="text-black"
                                style={{ cursor: "pointer" }}
                            />   Add Payment Gateway Icons
                            </button>
                        </div>

                    </div>

                    {showPaymentPopup && (
                        <div className="custom-modal-overlay">
                            <div className="custom-modal">
                                <h5 className="mb-4">Select Payment Gateway Icons</h5>
                                <div className="row">
                                    {paymentIcons?.map((icon) => (
                                        <div className="col-md-6" key={icon.id}>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    id={`payment-${icon.id}`}
                                                    name={icon.name}
                                                    className="form-check-input"
                                                    checked={selectedPayments[icon.name] || false}
                                                    onChange={handlePaymentCheckboxChange}
                                                />
                                                <label htmlFor={`payment-${icon.id}`} className="form-check-label">
                                                    {icon.name}
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="d-flex justify-content-end mt-4">
                                    <button className="btn btn-secondary me-2" onClick={() => setShowPaymentPopup(false)}>
                                        Cancel
                                    </button>
                                    <button className="btn btn-success" onClick={handleAddPaymentIcons}>
                                        Add
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}




                    {/* API Error Message */}
                    {apiError && <p className="text-danger text-center">{apiError}</p>}

                    {/* Submit Button */}
                    <button type="submit" className="btn btn-primary" disabled={isLoading || updating}>
                        {isLoading || updating ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>

    );
}

export default AddCategory;
